import { yup } from "@utils/validation/validation";

export const FreeTextAnswerValidationSchema = yup.object().shape({
  text: yup.string().trim().required().max(50000),
});

export const PasswordFormValidationSchema = yup.object().shape({
  password: yup.string().trim().required(),
});
